(function ($) {

	var $crossRates = $('.cross-rate');
	var $showMoreButton = $('.cross-rate__show-more');
	var hiddenClass = 'cross-rate--hidden';

	function init() {
		hideEmptyCrossRateInputsExceptFirst();
		$showMoreButton.on('click', function () {
			if ($('html').hasClass('user-is-tabbing') === false) {
				$(this).blur();
			}

			showOneMoreCrossRateInput();
		});

		if (hasHiddenInputs()) {
			$showMoreButton.show();
		}
	}

	function hideEmptyCrossRateInputsExceptFirst() {
		$crossRates.each(function (index) {
			var $this = $(this);
			console.log("this");
			if (index !== 0 && $this.find('select').val() === '') {
				$this.addClass(hiddenClass);
			}
		});
	}

	function showOneMoreCrossRateInput() {
		$('.' + hiddenClass).first().removeClass(hiddenClass);

		if (hasHiddenInputs() === false) {
			$showMoreButton.hide();
		}
	}

	function hasHiddenInputs() {
		return $('.' + hiddenClass).length > 0;
	}

	init();

})(jQuery);
